import { useEffect } from "react";

interface UseNavigationBlockerOptions {
  when: boolean;
}

export const useNavigationBlocker = ({ when }: UseNavigationBlockerOptions) => {
  // 브라우저 새로고침/탭 닫기 방지
  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      console.log("[useNavigationBlocker] beforeunload 이벤트 발생 - 시스템 알림 표시");
      e.preventDefault();
      e.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [when]);
};